/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PaymentMode } from "./PaymentMode";
import type { ProductOption } from "./ProductOption";
import type { VisitOptionSelectionMetadataVisitTypePreference } from "./VisitOptionSelectionMetadataVisitTypePreference";
import type { VisitType } from "./VisitType";

/**
 * Visit-option metadata accumulated across progression steps.
 *
 * Step completion enforces required fields; unrelated progression metadata is ignored.
 */
export interface VisitOptionSelectionMetadata {
  type: "visit_option_selection";
  payment_product_option?: ProductOption | null;
  payment_visit_type?: VisitType | null;
  visit_type_preference?: VisitOptionSelectionMetadataVisitTypePreference;
  /** How the visit is being paid for ('insurance' | 'cash'). Vendor-neutral: whether an insurance visit is Bridge-backed is derived server-side from the eligibility check, not from this selection. */
  payment_mode?: PaymentMode | null;
  /** Vendor-neutral id of the eligibility check run the price was based on, set when payment_mode is 'insurance'. (From PatientResponsibilityResponse.run_id.) */
  insurance_eligibility_check_id?: string | null;
}
